import React from 'react';
import classnames from 'classnames';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { STEPS } from '../../../redux/box-builder/box-builder.constants';
import BoxIntroductionInfo from './components/box-introduction-info';
import BoxNaming from './components/box-naming';
import { BoxTypeSelection } from './components/box-type-selection';
import { CustomBoxSelection } from './components/custom-box-selection';
import BrownBoxSelection from './components/brown-box-selection';
import ColoredBoxSelection from './components/colored-box-selection';
import FullyCustomBoxSelection from './components/fully-custom-box-selection';
import css from './cart-box-builder-popup.scss';
import NonVectorImageUploadPopup from './components/non-vector-image-upload-popup';
const classes = {
  paper: css.paper
};
const classesWide = {
  paper: css.paperWide
};
const titleClasses = {
  root: css.header
};
const ADDITIONAL_CONTENT_CLASS = {
  [STEPS.BOX_INTRODUCTION_INFO]: css.boxIntroductionInfo,
  [STEPS.BOX_NAMING]: css.boxNaming,
  [STEPS.BOX_TYPE_SELECTION]: css.boxTypeSelection,
  [STEPS.CUSTOM_BOX_SELECTION]: css.customBoxSelection,
  [STEPS.BROWN_BOX_SELECTION]: css.customBoxSelection,
  [STEPS.FULLY_CUSTOM_BOX_SELECTION]: css.fullyCustomBoxSelection,
  [STEPS.COLORED_BOX_SELECTION]: css.coloredBoxSelection,
  [STEPS.SELECT_PRODUCTS_FOR_BOX]: css.selectProductsForBox
};
const STEP_TO_CONTENT_COMPONENT = {
  [STEPS.BOX_INTRODUCTION_INFO]: /*#__PURE__*/React.createElement(BoxIntroductionInfo, null),
  [STEPS.BOX_NAMING]: /*#__PURE__*/React.createElement(BoxNaming, null),
  [STEPS.BOX_TYPE_SELECTION]: /*#__PURE__*/React.createElement(BoxTypeSelection, null),
  [STEPS.CUSTOM_BOX_SELECTION]: /*#__PURE__*/React.createElement(CustomBoxSelection, null),
  [STEPS.FULLY_CUSTOM_BOX_SELECTION]: /*#__PURE__*/React.createElement(FullyCustomBoxSelection, null),
  [STEPS.COLORED_BOX_SELECTION]: /*#__PURE__*/React.createElement(ColoredBoxSelection, null),
  [STEPS.BROWN_BOX_SELECTION]: /*#__PURE__*/React.createElement(BrownBoxSelection, null),
  [STEPS.SELECT_PRODUCTS_FOR_BOX]: /*#__PURE__*/React.createElement("div", {
    className: css.blankDiv
  }),
  [STEPS.SELECT_ADDONS_FOR_BOX]: /*#__PURE__*/React.createElement("div", {
    className: css.blankDiv
  })
};
const animationClasses = {
  enter: css.enter,
  enterActive: css.enterActive,
  exit: css.exit,
  exitActive: css.exitActive
};
export default function CartBoxBuilderPopup(props) {
  const {
    open,
    onClose,
    currentStep,
    hasUnsavedChanges
  } = props;
  const content = /*#__PURE__*/React.createElement("div", {
    className: classnames(css.animatedContent, ADDITIONAL_CONTENT_CLASS[currentStep])
  }, /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: animationClasses,
    key: currentStep,
    timeout: 200
  }, STEP_TO_CONTENT_COMPONENT[currentStep])));
  const getPopupClasses = () => {
    return currentStep === STEPS.BOX_TYPE_SELECTION ? classesWide : classes;
  };
  const contentClass = currentStep === STEPS.BOX_TYPE_SELECTION ? css.contentWrapperWide : css.contentWrapper;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PopupDialog, {
    open: open,
    onClose: () => onClose(hasUnsavedChanges),
    dataPopup: "CartBoxBuilderPopup",
    content: content,
    classes: getPopupClasses(),
    titleHeader: css.header,
    titleClasses: titleClasses,
    contentClass: contentClass,
    closeClass: css.closeClass
  }), /*#__PURE__*/React.createElement(NonVectorImageUploadPopup, null));
}